import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import BlogCard from "../../../components/common/blogCard";
import Donate_love from "../../../assests/images/header-dropdown-image/donation-love.svg"
import DonationOne from '../../../assests/images/donationone.webp';
import DonationTwo from '../../../assests/images/donationtwo.webp';
import DonationThree from '../../../assests/images/donationthree.webp';

import {
    GuidesMainBanner,
    GuidesMain,
    GuidesTextBlock,
    GuidesTitle,
    GuidesPre,
    GuidesInnerDonate,
    GuidesInnerNonProfit,
    GuidesNonProfitImage,
    GuidesNonProfitTextBox,
    GuidesNonProfitPre, 
    GuidesColNonProfit,
    GuidesHolidayGiving,
    GuidesHolidayTitle,
    GuidesHolidayGivingButton,
   
    GuidesHolidayGroup,
    GuidesHolidayBox,
    GuidesHolidayImage,
    GuidesHolidayContent,
    GuidesHolidayHeading,
    GuidesHolidayText,

} from "./guidesStyle";
import { useNavigate } from "react-router-dom";
import {  Title,
    WriteReviewSection,
    ReviewText, 
    ReviewRightSection,
    RightBanner,
   } from "../../../components/common/commonSubBanner/commonSubBannerStyle";
import ReviewImage from "../../../assests/images/review.webp";
import { blogListHandler } from "../../../redux/slices/blogs/blogList-slice";
import { useDispatch,useSelector } from "react-redux";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";

const Guides = () => {
    const navigate = useNavigate();
    const dispatch: any = useDispatch();
    const blogList : any = useSelector((state:any) => state?.blogList?.data?.results);
    useEffect(() =>{
        dispatch(blogListHandler("","","",""));
    },[])
    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle=""
            ogDescription=""
            ogUrl=""
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
    <>

        <GuidesMainBanner>
            <WriteReviewSection className="giving-guides-banner">
                <Container className="cont-w"> 
                    <Row>
                        <Col lg={6} sm={12} md={12}>
                            <Title>The GreatNonprofits Holidays Giving Guide</Title>
                            <ReviewText>With the holidays drawing near, now is a great time to share the spirit of giving with our Top-Rated nonprofits! Nonprofit organizations receive the majority of their donations around the holiday season. Here are some tips to help guide your giving strategy and increase your impact on the world!</ReviewText>
                        </Col>
                        <Col lg={6} sm={12} md={12}>
                            <RightBanner className="left_banner">
                                <ReviewRightSection>
                                    <Image src={ReviewImage} alt="ReviewImage"/>
                            </ReviewRightSection>
                            </RightBanner>
                        </Col>
                    </Row>
                </Container>
            </WriteReviewSection>
        </GuidesMainBanner>
        <GuidesMain>
            <GuidesInnerDonate>
                <Container className="cont-w">
                    <Row>
                        <GuidesTextBlock as={Col} col="12">
                            <GuidesTitle>{MESSAGE.giveWithHeartAndHead}</GuidesTitle>
                            <GuidesPre>Find the organizations that work toward your goals, vision, and values. A great place to start is on our <a href="#!" onClick={() => navigate('/awards/browse')}><span>Campaigns page</span></a>, where you can find Top-Rated organizations supporting a range of topics and issues. Here are some that might interest you!</GuidesPre>
                        </GuidesTextBlock>
                    </Row>
                    <Row>
                        <BlogCard blogData={blogList}/>
                    </Row> 
                </Container>
            </GuidesInnerDonate>

            <GuidesInnerNonProfit>
                <Container className="cont-w">
                    <Row>
                        <GuidesColNonProfit as={Col} col="12">
                            <GuidesNonProfitImage>
                                <Image src={Donate_love} alt="Donate Love" width="168" height="168" />
                            </GuidesNonProfitImage>
                            <GuidesNonProfitTextBox>
                                <GuidesNonProfitPre>{MESSAGE.donateTopRatedNonprofitToday}</GuidesNonProfitPre>
                                <Button className="learn-qualify-btn" onClick={() => navigate('/awards/browse')} >{MESSAGE.viewAllTopRatedNonProfit}</Button>
                            </GuidesNonProfitTextBox>
                        </GuidesColNonProfit>
                    </Row>
                </Container>
            </GuidesInnerNonProfit>

            <GuidesHolidayGiving>
                <Container className="cont-w">
                      <GuidesHolidayTitle>{MESSAGE.tipsForHolidayGiving}</GuidesHolidayTitle>
                    <Row>

                        <GuidesHolidayGroup>
                            
                            <GuidesHolidayBox>
                                <GuidesHolidayImage><Image src={DonationOne}/></GuidesHolidayImage>
                                <GuidesHolidayContent>
                                    <GuidesHolidayHeading>Know Where Money Is Going</GuidesHolidayHeading>
                                    <GuidesHolidayText>Make sure your donation goes where you intend it to go. Should you donate to a specific program or to the nonprofit&#8217;s general funds? Is there a certain fund you want to give to within the nonprofit? Call or email the organization to understand your giving options, and ask where the money is needed most.</GuidesHolidayText>
                                </GuidesHolidayContent>
                            </GuidesHolidayBox>

                            <GuidesHolidayBox>
                                <GuidesHolidayImage><Image src={DonationTwo}/></GuidesHolidayImage>
                                <GuidesHolidayContent>
                                    <GuidesHolidayHeading>Read the Reviews</GuidesHolidayHeading>
                                    <GuidesHolidayText>Get an on-the-ground look at the nonprofit&#8217;s work through GreatNonprofits reviews. Read about people's experiences with a nonprofit as volunteers, donors, board members, or clients.</GuidesHolidayText>
                                    <GuidesHolidayText>These will help you understand how the organization works and the real, human impact it has. Add your own reviews to organizations you're passionate about so that others can benefit from them!</GuidesHolidayText>
                                </GuidesHolidayContent>
                            </GuidesHolidayBox>

                            <GuidesHolidayBox>
                                <GuidesHolidayImage><Image src={DonationThree}/></GuidesHolidayImage>
                                <GuidesHolidayContent>
                                    <GuidesHolidayHeading>Become an Expert</GuidesHolidayHeading>
                                    <GuidesHolidayText>Once you've identified a nonprofit that aligns with your values and interests, check out their website. Contact them via email to see if they have any events or tours available where you can learn more about them!</GuidesHolidayText>
                                </GuidesHolidayContent>
                            </GuidesHolidayBox>

                        </GuidesHolidayGroup>

                        <GuidesHolidayGivingButton><Button className="btn-outline-success-blue" onClick={() => navigate('/awards/browse')} >{MESSAGE.viewAllTopRatedNonProfit}</Button></GuidesHolidayGivingButton>
                   </Row>
                </Container>
            </GuidesHolidayGiving>
        </GuidesMain>
    </></>)
};
export default Guides;